import React, { useEffect } from "react";
import { makeStyles } from '@material-ui/styles';

import { CircularProgress } from '@material-ui/core';

import { withRouter } from 'react-router-dom';
import withShowToast from '../../../hocs/with_show_toast.js';
import withCurrentUser from "../../../hocs/with_current_user.js";
import { compose } from 'redux';

import URLParams from "../../../utils/url_params.js";

import Routes from "../../routes.js";

import IdentifyCurrentUserUseCase from "../../../use_cases/users/current_user/identify_current_user_use_case.js";

const pageStyles = makeStyles(theme => ({
  root: { 
    backgroundColor: "white",
    minHeight: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  loader: {
    display: "block",
    margin: "0px auto"
  },
}));

const ProfileIdentificationSuccessPage = (props) => {

  const { history, showErrorMessage, loadUser } = props;
  const identificationToken = URLParams.get("identification_token");

  useEffect(() => {
    IdentifyCurrentUserUseCase.execute(identificationToken)
    .then((result) => {
      loadUser(() => {
        history.replace(Routes.profile());
      })
    })
    .catch((result) => {
      showErrorMessage(result.message);
      history.replace(Routes.profile());
    })
  }, [])

  const classes = pageStyles();

  return (
    <div className = { classes.root } >
      <CircularProgress className = { classes.loader }/> 
    </div>
  );
}

export default compose(withRouter, withShowToast, withCurrentUser)(ProfileIdentificationSuccessPage);
